import type { HTMLAttributes } from 'react';

import { TextEditor, classNames } from '@movingimage-evp/mi-ui-component-library';

import styles from './language-editor.module.css';

type Props = {
  language: string;
  description: string | undefined;
  onDescriptionChange: (value: string, language: string) => void;
  onBlur?: () => void;
} & HTMLAttributes<HTMLDivElement>;

export function LanguageEditor({ language, description, onDescriptionChange, onBlur, className }: Props) {
  return (
    <div className={classNames(styles.editorsWrapper, className)}>
      <TextEditor
        key={language}
        data-testid={`description-rich-text-editor-${language}`}
        value={description}
        className={styles.richTextEditor}
        editorOptions={{ autofocus: 'end' }}
        onChange={(html) => {
          if (html === description) return; // Prevent unnecessary updates if the value hasn't changed
          onDescriptionChange(html, language);
        }}
        onBlur={onBlur}
      />
    </div>
  );
}
